import { useEffect, useMemo, useState, useCallback } from 'react';
import { isClientSide } from '~/src/helpers/ssr';

/**
 * Проверяет переданное медиа-выражение, возвращает результат проверки
 * @param {string} mediaQueryString медиавыражение вида: '(max-width: 1000px)'
 * @return {[boolean]}
 */

export const useMatchMedia = (mediaQueryString: string) => {
    const _mql = useMemo<MediaQueryList | null>(() => {
        if (isClientSide()) {
            return window.matchMedia(mediaQueryString);
        } else {
            return null;
        }
    }, []);

    const getMatch = useMemo(() => {
        return _mql ? _mql.matches : false;
    }, [_mql]);

    const [isMatch, setIsMatch] = useState(getMatch);

    const handleMediaChange = useCallback((e) => {
        setIsMatch(e.matches);
    }, []);

    useEffect(() => {
        if (!_mql) {
 return;
}

        if ('function' === typeof _mql.addEventListener) {
            _mql.addEventListener('change', handleMediaChange);
        }

        return () => {
            if ('function' === typeof _mql.removeEventListener) {
                _mql.removeEventListener('change', handleMediaChange);
            }
        };
    }, [_mql]);

    return [isMatch];
};
